orders-planner-dialog-save-tasks-memo(class="{show: isShow}")
  .orders-planner-dialog-save-tasks-memo.popper
    forms-tasks-memos-save(tag-scope="forms_tasks_memos_save" data-dialog="{true}")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.save-tasks-memo');
